import { useContext } from "react";
import { AnimalContext } from "common/providers/AnimalProvider";

export const useAnimal = () => useContext(AnimalContext);

export default useAnimal;
